<template>
  <div id="index_box">
    <el-table :data="shangwuList" style="width: 100%">
      <el-table-column label="商务">
        <template slot-scope="scope">{{ scope.row.adminName }}</template>
      </el-table-column>
      <el-table-column label="本月">
        <template slot-scope="scope">￥{{ tfDecimals(scope.row.currentMonthTotal) }}</template>
      </el-table-column>
      <el-table-column label="上月">
        <template slot-scope="scope">￥{{ tfDecimals(scope.row.lastMonthTotal) }}</template>
      </el-table-column>
      <el-table-column label="历史统计">
        <template slot-scope="scope">￥{{ tfDecimals(scope.row.historyTotal) }}</template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="pageInfo.currentPage"
      :page-sizes="pageInfo.pageSizeList"
      :page-size="pageInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalPage"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>
<script>
import {
  toDecimal2
} from '@/utils/index'
export default {
  props: ['shangwuList', 'totalPage'],
  data () {
    return {
      pageInfo: {
        limit: 30,
        allCount: 0,
        currentPage: 1,
        currentPageCount: 0,
        pageSizeList: [30, 50, 100, 150, 200, 300],
        showEdit: false // 是否显示快捷编辑代码框
      }
    }
  },
  methods: {
    handleSizeChange (val) {
      this.pageInfo.limit = val
      this.pageInfo.currentPage = 1
      this.fetchData()
    },
    handleCurrentChange (val) {
      this.pageInfo.currentPage = val
      this.fetchData()
    },
    tfDecimals (x) {
      return toDecimal2(x)
    }

  }
}
</script>
